import { MainContainer, MainContainerFullWidth } from "../../styles/basicStyles";
import { FC } from "react";
import { useTranslation } from "next-i18next";
import { CompanyType } from "../../models/company";
import { colors } from "../../styles/colors";
import RelatedCaseStudies from "./components/relatedCaseStudies";
import RelatedBlogPosts from "./components/relatedBlogPosts";
import ContactBanner from "../../components/views/contactBanner";
import GlobalBanner from "../../components/views/globalBanner";
import Metatags from "../../components/metatags";
import animationData from '../../../public/assets/no_records_animation.json'
import NoRecords from "../../components/noRecords";

interface Props {
  data: CompanyType;
}

const Company: FC<Props> = ({ data }) => {
  const { t, i18n: { language } } = useTranslation();

  const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <>
      <Metatags
        title={data.meta_title && data.meta_title[language]}
        description={data.meta_description && data.meta_description[language]}
        keywords={data.meta_keywords && data.meta_keywords[language]}
        image={data?.logo_detail?.url}
      />
      <GlobalBanner
        logo={data?.logo_detail?.url}
        title={data.name}
        description={data?.description[language]}
        bgColor={colors.desertStorm}
        blacktext
      />
      <MainContainer>
        {
          (data?.case_studies?.length > 0 || data?.posts?.length > 0) ?
          <>
            {data?.case_studies?.length > 0 && <RelatedCaseStudies caseStudies={data?.case_studies} />}
            {data?.posts?.length > 0 && <RelatedBlogPosts blogPosts={data?.posts} hasCaseStudies={data?.case_studies?.length > 0} />}
          </>
          :
          <NoRecords text='NO_COMPANY_CONTENT' />
        }
      </MainContainer>
      <MainContainerFullWidth>
        <ContactBanner />
      </MainContainerFullWidth>
    </>
  );
};

export default Company;
